import { Button, useDisclosure, Icon } from '@wegroup/design-system';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { ThemeContext } from 'styled-components';
import AreYouSureModal from '../../../../../../common/src/components/AreYouSureModal';
import { useFlowsSelector } from '../../../../../../common/src/utils/globalVariables';
import { useFlowInfoBySessionId } from '../../../../../../flows/src/api/getFlowInfo';
import { useFlowsSession } from '../../../../../../flows/src/api/getFlowsSessionById';
import useSessionId from '../../../../../../flows/src/hooks/useSessionId';
import useStartFlow from '../../../../../../flows/src/hooks/useStartFlow';
import { clearComparisonMatrix } from '../../../../store/redux/slices/offersSlice';
import { useLouiseDispatch } from '../../../../store/redux/store';
import useIsNewRoute from '../../hooks/useIsNewRoute';

const OffersSidebarBackButton: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const sessionId = useSessionId();
  const dispatch = useLouiseDispatch();
  const flowId = useFlowsSelector((state) => state.flows.metaData.flowId);
  const { data: session } = useFlowsSession(sessionId);
  const { data: flowInfo } = useFlowInfoBySessionId(sessionId);
  const startFlow = useStartFlow();
  const isNewRoute = useIsNewRoute();

  // not using useTheme because the need of 'isImmo' prop from the theme
  const theme = useContext(ThemeContext);

  const { isOpen, onClose, onOpen } = useDisclosure();

  const handleOnClick = () => {
    if (flowInfo?.previous) {
      history.push(`/flows/${flowInfo.previous}/questions/${sessionId}`);
      startFlow({
        flowId: flowInfo.previous,
        sessionId,
        partyId: session?.prospect.id,
      });
    } else {
      history.push(`/flows/${flowInfo?.id || flowId}/questions/${sessionId}`);
      startFlow({
        flowId: flowInfo?.id || flowId,
        sessionId,
        partyId: session?.prospect.id,
      });
    }
    dispatch(clearComparisonMatrix());
    onClose();
  };

  return (
    <>
      <AreYouSureModal
        title={t('Go back?')}
        description={t(
          'Are you sure you want to go back? You will lose any changes made to the offers and no offers will remain selected',
        )}
        onClose={onClose}
        onConfirm={handleOnClick}
        isOpen={isOpen}
      />
      <Button
        ml="1"
        mr="4"
        color={theme['isImmo'] ? theme.secondary[200] : theme.secondary[300]}
        variant="link"
        leftIcon={
          <Icon
            name="GeneralActionsArrowLeft"
            color={
              theme['isImmo'] ? theme.secondary[200] : theme.secondary[300]
            }
          />
        }
        onClick={isNewRoute ? handleOnClick : onOpen}
      >
        {t('Back to questions')}
      </Button>
    </>
  );
};

export default OffersSidebarBackButton;
